import { DeleteOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, ConfigProvider, Form, Input, message, Modal, Radio } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { addUser, deleteUser, fetchUserList, modifyUser } from '../../apis/user'
import MainTable from '../../components/Basic/MainTable'
import useParams from '../../hook/useParams'
import { FormButton, SearchWrapper, WhiteWrapper } from './adminAccount.styled'
import PopupConfirm from '../../components/Basic/PopupConfirm'

function AdminAccount () {
  const { t: ln_t } = useTranslation()
  const params = useParams({ includes: 'creator', role: 'admin' })
  const { handleFetchParams, fetchParams } = params
  const [form] = Form.useForm()
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [accountExist, setAccountExist] = useState(false)

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`user.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`user.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const handleDelete = data => {
    const { name, id } = data
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('sidebar.adminAccount')}`,
      content: `${ln_t('message.confirm.delete')} ${name}?`,
      onOk: async () => {
        const result = await deleteUser(id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const handleChangeStatus = async (record, update) => {
    const result = await modifyUser(record?.id, update)
    if (result?.status === 200) {
      message.success(ln_t('message.success.modify'))
      handleFetchParams('add', {})
    }
  }

  const handleClose = () => {
    setShowModal(false)
    setAccountExist(false)
    form.resetFields()
  }

  const handleAdd = async value => {
    setIsLoading(true)
    if (!accountExist) {
      const result = await addUser({ ...value, role: 'admin' })
      if (result?.status === 200) {
        message.success(ln_t('login.emailSent'))
        handleFetchParams('add', {})
        handleClose()
      }
    }
    setIsLoading(false)
  }

  const apiFunc = async () => fetchUserList(fetchParams)
  const formatDate = (date, detail) => dayjs(date).format(detail ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')
  const columns = [
    { title: ln_t('util.name'), dataIndex: 'name', sorter: true },
    { title: ln_t('util.email'), dataIndex: 'email', sorter: true },
    { title: ln_t('dataSource.status'), dataIndex: 'status', render: (e, record) => <PopupConfirm type="status" checked={e} onConfirm={() => handleChangeStatus(record, { status: e ? 0 : 1 })} /> },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', render: e => formatDate(e), sorter: true },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', render: e => formatDate(e), sorter: true },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, data) => <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(data)} />
    }
  ]
  useEffect(() => {
    handleFetchParams('add', { role: 'admin' })
  }, [])

  const checkAccount = async e => {
    console.log(1234)
    const email = e.target.value
    if (!email || !email.includes('@')) return setAccountExist(false)
    const check = await fetchUserList({ email, role: 'admin' })

    if (check?.status === 200) return setAccountExist(check?.data?.length ? check?.data?.[0]?.id : false)
    setAccountExist(false)
  }

  const emailWarning = accountExist ? { validateStatus: 'warning', help: ln_t('message.info.accountExist') } : {}
  return (
    <>
      <WhiteWrapper>
        <h3>{ln_t('sidebar.adminAccount')}</h3>
        <SearchWrapper>
          <Input.Search
            style={{ width: '400px' }}
            placeholder={ln_t('util.search')}
            onSearch={e => handleFetchParams('add', { name_like: `%${e}%` })}
            enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
          />
          <Button type="default" icon={<PlusOutlined />} onClick={() => setShowModal(true)}>
            {ln_t('util.add')} {ln_t('sidebar.adminAccount')}
          </Button>
        </SearchWrapper>

        <MainTable
          columns={columns}
          rowKey="id"
          apiFunc={apiFunc}
          params={params}
        />
      </WhiteWrapper>

      <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
        <Modal title={`${ln_t('util.add')} ${ln_t('user.user')}`} open={showModal} footer={null} onCancel={handleClose}>
          <Form form={form} layout="vertical" requiredMark={false} onFinish={e => handleAdd(e)} style={{ marginTop: '16px' }}>
            <Form.Item {...defConfig('name', 'input')} >
              <Input placeholder={defPlaceholder('name', 'input')} />
            </Form.Item>
            <Form.Item {...defConfig('email', 'input')} {...emailWarning} rules={[{ required: true, message: defPlaceholder('email', 'input') }, { type: 'email', message: ln_t('message.error.emailFormat') }]}>
              <Input placeholder={defPlaceholder('email', 'input')} onChange={e => checkAccount(e)} />
            </Form.Item>
            <Form.Item {...defConfig('status', 'select')} initialValue={1}>
              <Radio.Group
                options={[{ value: 1, label: ln_t('util.enable') }, { value: 0, label: ln_t('util.disable') }]}
                optionType="button"
                buttonStyle="solid"
              />
            </Form.Item>
            <FormButton>
              <Button type="default" onClick={handleClose}>{ln_t('util.cancel')}</Button>
              <Button type="primary" htmlType="submit" loading={isLoading}>{ln_t('util.confirm')}</Button>
            </FormButton>
          </Form>
        </Modal>
      </ConfigProvider>
    </>
  )
}

export default AdminAccount
